<template>
  <div class="news-list">
    <div class="title-mod">
      <div class="text">最新文章</div>
    </div>
    <div class="list">
      <ul v-if="list.length>0">
        <li v-for="(item,index) in list" :key="index" class="am-text-truncate" >
          <router-link :to="'/article/'+item.article_id" target="_blank">
            {{item.title}}
          </router-link>
        </li>
      </ul>
      <div class="no-data" v-else>暂无文章</div>
    </div>
  </div>
</template>
<script> 
  export default {
    data(){
      return{
        list:[],
      }
    },
    created(){
       this.getList({
            typeId: 'port',
            rowNum: '12',
        }).then(result => {
            this.list = result
        })
    }
  }

</script>

<style lang="scss">
  .news-list {
    margin-top: 20px;
    .title-mod {
      background-color: $primary;
      height: 26px;
      line-height: 26px;
      padding-left: 30px;
       margin-bottom: 12px;
      .text{
        // background-image: url(~@/assets/images/jiantou.png);
        background-repeat: no-repeat;
        background-position: 6px;
        font-size: 20px;font-weight: bold;
        background-color: white;
        display: inline-block;
        padding-left: 20px;
            color: $primary;
        padding: 0 16px 0 32px;
   
      }
    }
    .list {
      ul{
        li{
              font-size: 12px;
              padding: 10px 0;
          background-repeat: no-repeat;
          background-position: 2rem;
          padding-left: 12px;
          transition: .3s;
          border-bottom: 1px solid white;
          background-color: #d2ebfe;
    &:hover{
      padding-left: 16px;
      font-weight: bold;
    }
        }
      }
      
    }
  }

</style>
